import { useEffect } from "react";
import { getEnvConfig } from "helpers/environment-config";

interface RedirectToAuthUIProps {
  to: string;
}

const RedirectToAuthUI = ({ to }: RedirectToAuthUIProps) => {
  useEffect(
    () =>
      void (async () => {
        const authUrl = await getEnvConfig("authUIUrl");
        window.location.assign(`${authUrl}${to}`);
      })(),
    []
  );

  return null;
};

export default RedirectToAuthUI;
